export default __webpack_public_path__ + "static/media/aeurs.d3bdc8fd.svg";